import { render, staticRenderFns } from "./performanceScale.vue?vue&type=template&id=5dc4410d&scoped=true"
import script from "./performanceScale.vue?vue&type=script&lang=js"
export * from "./performanceScale.vue?vue&type=script&lang=js"
import style0 from "./performanceScale.vue?vue&type=style&index=0&id=5dc4410d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc4410d",
  null
  
)

export default component.exports